import { render } from "./associationAdministrator.vue?vue&type=template&id=66aaa8ff&scoped=true"
import script from "./associationAdministrator.vue?vue&type=script&lang=js"
export * from "./associationAdministrator.vue?vue&type=script&lang=js"

import "./associationAdministrator.vue?vue&type=style&index=0&id=66aaa8ff&lang=scss&scoped=true"
import "./associationAdministrator.vue?vue&type=style&index=1&id=66aaa8ff&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66aaa8ff"]])

export default __exports__